import type { CSSProperties } from 'react';
import React from 'react';
import styled from 'types/theme.types';
import { InfoCircleOutlined } from '@ant-design/icons';
import Tooltip from 'components/common/bridged-tooltip';

interface InfoProps {
  style?: Omit<CSSProperties, 'textDecorationSkipInk' | 'transformBox'>;
  tooltip?: string | React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Info: React.FunctionComponent<InfoProps> = ({ tooltip, style, className, onClick }) => (
  // className sits on the icon, not the tooltip: antd forwarded it to the child anyway, so this is the
  // same element without depending on a passthrough the wrapper's prop surface lacks.
  <Tooltip title={tooltip}>
    <StyledIcon data-e2e="info-icon" className={className} onClick={onClick} style={style} />
  </Tooltip>
);

const StyledIcon = styled(InfoCircleOutlined)`
  /* icon-primary, not icon-information: every other inline icon inherits the text colour, and the
     information blue read as a stray link beside black labels on Projects, Environments and the
     settings forms (UI-polish review). Information-blue stays for real info Alerts. */
  color: var(--icon-primary-standalone);
`;

export default Info;
